import { render, staticRenderFns } from "./top-news.vue?vue&type=template&id=099bd9a4"
import script from "./top-news.vue?vue&type=script&lang=js"
export * from "./top-news.vue?vue&type=script&lang=js"
import style0 from "./top-news.vue?vue&type=style&index=0&id=099bd9a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports